import { ShopJsonldShopLocatorRead } from '@/api/generated';
import Avatar from '@/atoms/Avatar';
import Button, { BUTTON_VARIANTS } from '@/atoms/Button';
import Chip from '@/atoms/Chip';
import ListItem from '@/molecules/ListItem';
import { useTranslation } from 'react-i18next';
import { SIZE, VARIANT_COLOR_ENUM } from 'types/utils';
import { localizedDistanceUnit } from 'utils/distances';

const ListItemFooter = ({ shop }: { shop: ShopJsonldShopLocatorRead }) => {
  const { t } = useTranslation();

  return (
    <div className="flex gap-2">
      <Button href={`/events?shopId=${shop.id}`} variant={BUTTON_VARIANTS.SECONDARY}>
        {t('locator.cta.events')}
      </Button>
      {shop.user?.uniqueId && <Button href={`/profile/${shop.user.uniqueId}`}>{t('locator.cta.profil')}</Button>}
    </div>
  );
};
const ShopsList = ({ shops, displayDistance }: { shops: ShopJsonldShopLocatorRead[]; displayDistance?: boolean }) => {
  const {
    i18n: { language },
  } = useTranslation();

  return shops?.map((shop) => (
    <ListItem
      key={shop['@id']}
      footerProps={{
        children: shop.id && <ListItemFooter shop={shop} />,
        label:
          displayDistance && shop.distance ? (
            <Chip className="h-fit" color={VARIANT_COLOR_ENUM.NUBLU}>
              {localizedDistanceUnit(shop.distance, language)}
            </Chip>
          ) : undefined,
      }}
      headerProps={{
        leadText: shop.name,
        imageNode: <Avatar alt="" size={SIZE.MD} src={shop?.user?.avatarPath} />,
        subText: `${shop?.user?.addresses?.[0]?.street} ${shop?.user?.addresses?.[0]?.city}`,
      }}
    />
  ));
};
export default ShopsList;
